import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center flex-col p-4"
};
const _hoisted_2 = {
  class: "flex-center text-4xl mb-2"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "span"
}, ":", -1);
const _hoisted_4 = {
  class: "flex-center flex-col"
};
import Icon from "@/modules/vue/components/Icon.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'GoalIncident',
  props: {
    liveIncident: null
  },
  setup(__props) {
    const props = __props;
    const isHomeGoal = computed(() => {
      const incident = props.liveIncident.incident;
      return incident.player.teamId === props.liveIncident.match.homeTeam.id || props.liveIncident.incident.player.teamId === props.liveIncident.match.awayTeam.id && incident.ownGoal;
    });
    const revealed = ref(false);
    onMounted(async () => {
      await waitFor(2000);
      revealed.value = true;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Icon, {
        icon: _ctx.IconEnum.Futbol,
        size: "4rem",
        class: _normalizeClass([{
          'text-red-600': __props.liveIncident.incident.ownGoal
        }, "mb-4"])
      }, null, 8, ["icon", "class"]), _createElementVNode("div", {
        class: _normalizeClass({
          invisible: !revealed.value
        })
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(["span", {
          'font-bold animate-pulse': _unref(isHomeGoal)
        }])
      }, _toDisplayString(__props.liveIncident.match.homeGoals), 3), _hoisted_3, _createElementVNode("div", {
        class: _normalizeClass(["span", {
          'font-bold animate-pulse': !_unref(isHomeGoal)
        }])
      }, _toDisplayString(__props.liveIncident.match.awayGoals), 3)]), _createElementVNode("div", _hoisted_4, [_createVNode(EntityLink, {
        entity: __props.liveIncident.incident.team,
        disabled: "",
        class: "mb-2"
      }, null, 8, ["entity"]), _createVNode(EntityLink, {
        entity: __props.liveIncident.incident.player,
        disabled: ""
      }, null, 8, ["entity"])])], 2)]);
    };
  }
});